<!-- 采购退货 0 添加 1 查看 2 编辑 3 无订单模式 4 修改-->
<template>
  <div class="business-content-main purreturn-order-edit" v-loading="loading">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
    </div>
    <!--form-->
    <div class="section-title">
      <div>
        <span>售后订单信息</span>
      </div>
      <div>
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click.stop="submitForm(0)"
          v-if="permission.save"
          :disabled="stopSubmit"
          >{{ permission.save }}</el-button
        >
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click.stop="submitForm(1)"
          v-if="permission.submit"
          :disabled="stopSubmit"
          >{{ permission.submit }}</el-button
        >
      </div>
    </div>
    <div class="search-ctn">
      <el-form
        :model="submitData"
        ref="formMsg"
        label-width="100px"
        style="width: 100%; padding-right: 30px; padding-left: 30px"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <el-form-item label="出仓仓库" prop="WarehouseId">
                <el-select
                  v-model="submitData.WarehouseId"
                  :disabled="dataReadonly"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                  @visible-change="warehouseVisibleChange($event)"
                >
                  <el-option
                    v-for="optionItem in warehouseList"
                    :key="optionItem.WarehouseId"
                    :label="optionItem.WarehouseName"
                    :value="optionItem.WarehouseId"
                    ><span style="float: left">{{
                      optionItem.WarehouseName
                    }}</span>
                    <span
                      v-if="optionItem.Type == 1"
                      style="float: right; color: #8492a6; font-size: 13px"
                      >（前置仓）</span
                    ></el-option
                  >
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="选择供应商" prop="EntpCusId">
                <el-input
                  disabled
                  v-model.trim="submitData.EntpCusName"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="售后时间" prop="ReturnTime">
                <el-date-picker
                  style="width: auto"
                  :disabled="dataReadonly"
                  v-model="submitData.ReturnTime"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              <el-form-item label="售后原因" prop="Reasons">
                <el-input
                  v-model="submitData.Reasons"
                  :disabled="dataReadonly"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="section-title">
      <div>
        <span>退款申请</span>
        <span style="font-size: 14px; color: red"
          >（ ※ 温馨提醒：当申请退款金额为0时，为仅退货的售后 ）</span
        >
      </div>
    </div>
    <div class="search-ctn">
      <el-form
        :model="submitData"
        ref="formMsg2"
        label-width="100px"
        style="width: 100%; padding-right: 30px; padding-left: 30px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="退款方式">
                <el-select
                  v-model="submitData.PayType"
                  :disabled="dataReadonly || submitData.ApplyIsConfirm"
                  placeholder="请选择"
                  style="width: 100%"
                  @visible-change="payTypeVisibleChange($event)"
                >
                  <el-option
                    v-for="item in payWayList"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-form-item label="申请退款金额">
                <el-input-number
                  v-model="submitData.ApplyAmount"
                  :disabled="dataReadonly || submitData.ApplyIsConfirm"
                  :min="0"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- table body -->
    <div class="section-title">
      <div>
        <span>退货商品</span>
        <span style="font-size: 14px; color: red"
          >（ ※ 温馨提醒：当不选择任何退货商品时，为仅退款的售后 ）</span
        >
      </div>
    </div>
    <div id="infinite-list" :style="{ height: infiniteListHeight + 'px' }">
      <ux-grid
        ref="infiniteTable"
        :data="dataList"
        keep-source
        :height="infiniteTableHeight"
        :checkboxConfig="{ highlight: true }"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        show-summary
        :summary-method="setSummaries"
        :row-style="setRowStyle"
        highlight-current-row
        empty-text="该售后单无退货商品"
      >
        <ux-table-column
          class-name="table-sort"
          type="index"
          title="序号"
          width="50"
        ></ux-table-column>

        <ux-table-column
          field="APCode"
          title="汽配编码"
          show-overflow-tooltip
          v-if="type == 0 || type == 1"
        >
          <template v-slot="{ row, rowIndex }">
            <div
              :class="[
                'sales-apcode div-padding-12',
                { 'special-border': !row.APCode },
              ]"
              @click="focusHandle(false, rowIndex, 'code')"
            >
              <img
                class="info-icon"
                src="../../../assets/images/info.png"
                title="配件信息"
                @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"
              />
              <span>{{ row.APCode ? row.APCode : "请点击选中汽配编码" }}</span>
              <el-tag v-if="row.State == 1" class="tag" type="warning"
                >已删除</el-tag
              >
            </div>
          </template>
        </ux-table-column>

        <ux-table-column
          field="APCode"
          title="汽配编码"
          edit-render
          show-overflow-tooltip
          v-else
        >
          <template v-slot:header="{ column }">
            <span class="color-red">*</span> {{ column.title }}
          </template>
          <template v-slot="{ row, rowIndex }">
            <div
              :class="[
                'sales-apcode div-padding-12',
                { 'special-border': !row.APCode },
              ]"
              @click="focusHandle(false, rowIndex, 'code')"
            >
              <img
                class="info-icon"
                src="../../../assets/images/info.png"
                title="配件信息"
                @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"
              />
              <span>{{ row.APCode ? row.APCode : "请点击选中汽配编码" }}</span>
              <el-tag v-if="row.State == 1" class="tag" type="warning"
                >已删除</el-tag
              >
            </div>
          </template>
          <template v-slot:edit="scope">
            <el-select
              :ref="'code' + scope.rowIndex"
              :disabled="
                dataReadonly ||
                (scope.row.hasLock && lastRowIndex !== scope.rowIndex)
              "
              allow-create
              default-first-option
              size="small"
              v-model="scope.row.APCode"
              value-key="APCode"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="汽配编码"
              @change="codeChange($event, scope.rowIndex)"
              @visible-change="apCodeVisibleChange($event)"
              @keyup.enter.native="addItem(true)"
              :remote-method="searchCode"
              v-select-scroll-more="searchCodeLoad"
              style="width: 100%"
              popper-class="el-select-style-gray"
            >
              <el-option
                v-for="optionItem in codeList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.APCode"
                :value="optionItem.APCode"
              >
                <div class="option-content">
                  <div class="project-Name">{{ optionItem.APCode }}</div>
                  <div class="project-Name">{{ optionItem.GoodName }}</div>
                  <div class="project-Name in-one-line">
                    {{ optionItem.AutoSerise }}
                  </div>
                  <div class="project-Name" v-if="changeCodeConfig">
                    {{ optionItem.GoodCode }}
                  </div>
                </div>
              </el-option>
              <el-option
                v-if="selectLoading"
                disabled
                value
                style="text-align: center"
              >
                加载中 <i class="el-icon-loading"></i>
              </el-option>
            </el-select>
          </template>
        </ux-table-column>

        <ux-table-column
          field="GoodName"
          title="配件名称"
          show-overflow-tooltip
          v-if="type == 0 || type == 1"
        >
          <template v-slot="{ row, rowIndex }">
            <div
              :class="['div-padding-12', { 'special-border': !row.GoodName }]"
              @click="focusHandle(false, rowIndex, 'partsNameSelect')"
            >
              {{ row.GoodName }}
            </div>
          </template>
        </ux-table-column>

        <ux-table-column
          field="GoodName"
          title="配件名称"
          edit-render
          show-overflow-tooltip
          v-else
        >
          <template v-slot:header="{ column }">
            <span class="color-red">*</span> {{ column.title }}
          </template>
          <template v-slot="{ row, rowIndex }">
            <div
              :class="['div-padding-12', { 'special-border': !row.GoodName }]"
              @click="focusHandle(false, rowIndex, 'partsNameSelect')"
            >
              {{ row.GoodName }}
            </div>
          </template>
          <template v-slot:edit="scope">
            <el-select
              ref="partsNameSelect"
              style="width: 100%"
              :disabled="
                dataReadonly ||
                (scope.row.hasLock && lastRowIndex !== scope.rowIndex)
              "
              allow-create
              size="small"
              v-model="scope.row.GoodName"
              :title="scope.row.GoodName"
              value-key="EntpTempGoodsId"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="配件名称"
              @change="nameChange($event, scope.rowIndex)"
              @visible-change="apNameVisibleChange($event)"
              @keyup.enter.native="addItem(true)"
              :remote-method="
                (query) => {
                  searchName(query, scope.row);
                }
              "
              v-select-scroll-more="searchNameLoad"
              popper-class="el-select-style-gray"
            >
              <el-option
                v-for="optionItem in nameList"
                :key="optionItem.EntpTempGoodsId"
                :data-msg="optionItem"
                :label="optionItem.GoodName"
                :value="optionItem"
              >
                <div class="option-content">
                  <div class="project-Name">{{ optionItem.GoodName }}</div>
                  <div class="project-Name">{{ optionItem.APCode }}</div>
                  <div class="project-Name in-one-line">
                    {{ optionItem.AutoSerise }}
                  </div>
                  <div class="project-Name" v-if="changeCodeConfig">
                    {{ optionItem.GoodCode }}
                  </div>
                </div>
              </el-option>
              <el-option
                v-if="selectLoading"
                disabled
                value
                style="text-align: center"
              >
                加载中 <i class="el-icon-loading"></i>
              </el-option>
            </el-select>
          </template>
        </ux-table-column>

        <ux-table-column
          field="AutoSeriseItem"
          title="车型"
          edit-render
          show-overflow-tooltip
        >
          <template v-slot:header="{ column }">
            <span class="color-red">*</span> {{ column.title }}
          </template>
          <template v-slot="{ row, rowIndex }">
            <div
              :class="['div-padding-12', { 'special-border': !row.AutoSerise }]"
              @click="focusHandle(false, rowIndex, 'autoSeriseSelect')"
            >
              {{ row.AutoSerise }}
            </div>
          </template>
          <template v-slot:edit="scope">
            <el-select
              ref="autoSeriseSelect"
              :disabled="
                dataReadonly ||
                (scope.row.hasLock && lastRowIndex !== scope.rowIndex)
              "
              allow-create
              size="small"
              v-model="scope.row.AutoSeriseItem"
              value-key="EntpTempGoodsId"
              :title="scope.row.AutoSerise"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="车系"
              @visible-change="autoSeriseVisibleChange($event, scope.row)"
              @keyup.enter.native="addItem(true)"
              :remote-method="
                (query) => {
                  searchAutoSerie(query, scope.row);
                }
              "
              v-select-scroll-more="searchAutoSerieLoad"
              @change="seriseChange($event, scope.rowIndex)"
              style="width: 100%"
              popper-class="el-select-style-gray"
            >
              <el-option
                v-for="option in seriesList"
                :key="option.EntpTempGoodsId"
                :data-msg="option"
                :label="option.AutoSerise"
                :value="option"
              >
                <div class="option-content">
                  <div class="project-Name" style="width: 300px">
                    {{ option.AutoSerise }}
                  </div>
                  <div class="project-Name">{{ option.GoodName }}</div>
                  <div class="project-Name">{{ option.APCode }}</div>
                  <div class="project-Name" v-if="changeCodeConfig">
                    {{ option.GoodCode }}
                  </div>
                </div>
              </el-option>
              <el-option
                v-if="selectLoading"
                disabled
                value
                style="text-align: center"
              >
                加载中 <i class="el-icon-loading"></i>
              </el-option>
            </el-select>
          </template>
        </ux-table-column>

        <ux-table-column
          field="Count"
          v-if="type == 0"
          title="采购数量"
          width="100"
        >
          <template v-slot="{ row }">
            <div class="div-padding-12">{{ row.PurchaseQuantity }}</div>
          </template>
        </ux-table-column>

        <ux-table-column
          field="Count"
          v-if="type == 0"
          title="可退数量"
          width="110"
        >
          <template v-slot:header="{ column }">
            {{ column.title }}
            <el-tooltip effect="dark" placement="bottom">
              <div slot="content">可退数量 = 已入仓数 - 已退数量</div>
              <span>
                <i
                  class="el-icon-warning-outline"
                  style="color: orange; margin-right: 5px"
                ></i>
              </span>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">
            <div class="div-padding-12">{{ row.CanReturnCount }}</div>
          </template>
        </ux-table-column>

        <ux-table-column field="Unit" title="单位" width="100">
          <template v-slot="{ row }">
            <div class="div-padding-12">
              {{ row.Unit }}
            </div>
          </template>
        </ux-table-column>

        <ux-table-column field="Count" title="废品数" width="100">
          <template v-slot="{ row }">
            <div class="div-padding-12">{{ row.WasteCount }}</div>
          </template>
        </ux-table-column>
        <ux-table-column field="Count" title="退货数量" width="160" edit-render>
          <template v-slot="{ row }">
            <div
              :class="[
                'div-padding-12',
                {
                  'special-border':
                    type == 0
                      ? row.ReturnCount > row.CanReturnCount
                      : row.ReturnCount == 0,
                },
              ]"
            >
              <span
                :class="{
                  'color-red':
                    type == 0
                      ? row.ReturnCount > row.CanReturnCount
                      : row.ReturnCount == 0,
                }"
                >{{ row.ReturnCount }}</span
              >
            </div>
          </template>
          <template v-slot:edit="scope">
            <div class="sales-input-cell">
              <el-input-number
                type="number"
                :ref="'count' + scope.rowIndex"
                :min="1"
                :max="
                  scope.row.CanReturnCount > 0
                    ? scope.row.CanReturnCount
                    : Infinity
                "
                :precision="0"
                controls-position="right"
                size="small"
                v-model="scope.row.ReturnCount"
                :disabled="dataReadonly"
                @change="priceChange"
              ></el-input-number>
            </div>
          </template>
        </ux-table-column>

        <ux-table-column field="Price" title="采购价" width="120" edit-render>
          <template v-slot:header="{ column }">
            {{ column.title }}
          </template>
          <template v-slot="{ row }">
            <div class="div-padding-12">
              <img
                src="@/assets/images/sup.png"
                title="采购历史"
                style="width: 27px; height: 27px"
                v-if="row.EntpTempGoodsId"
                @click="showHistories(row.EntpTempGoodsId)"
              />
              <span :class="{ 'color-red': row.PurchasePrice === 0 }">{{
                row.PurchasePrice
              }}</span>
            </div>
          </template>
          <template v-slot:edit="scope">
            <div class="sales-input-cell">
              <el-input-number
                size="small"
                :disabled="dataReadonly"
                :min="0"
                :precision="2"
                :step="0.01"
                controls-position="right"
                v-model="scope.row.PurchasePrice"
                placeholder="退单价"
                @input="priceChange"
                @keyup.enter.native="addItem(true)"
              ></el-input-number>
            </div>
          </template>
        </ux-table-column>

        <ux-table-column field="cgzj" title="采购总价" width="90">
          <template v-slot="{ row }">
            <div class="div-padding-12">
              {{
                row.PurchasePrice * row.ReturnCount
                  ? (row.PurchasePrice * row.ReturnCount).toFixed(2)
                  : 0
              }}
            </div>
          </template>
        </ux-table-column>

        <ux-table-column title="操作" width="120" v-if="type != 0 && type != 1">
          <template v-slot="{ row, rowIndex }">
            <div class="operate">
              <el-button
                size="small"
                @click="delItem(rowIndex)"
                icon="el-icon-delete"
                v-if="!dataReadonly"
              ></el-button>
              <el-button
                size="small"
                type="primary"
                @click="addItem(true)"
                icon="el-icon-plus"
                v-if="rowIndex + 1 === dataList.length && !dataReadonly"
              ></el-button>
              <el-button
                size="small"
                @click="upLock(rowIndex)"
                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                v-if="isLock && lastRowIndex !== rowIndex && !row.IsDelivery"
              ></el-button>
            </div>
          </template>
        </ux-table-column>
      </ux-grid>
    </div>
    <!--   配件信息     -->
    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
    <!--    采购历史    -->
    <el-dialog
      :close-on-click-modal="false"
      title="采购历史"
      :visible.sync="historyVisible"
      width="1200px"
    >
      <div v-if="historyVisible">
        <APPurchaseHistory
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeHistoryDialog"
        ></APPurchaseHistory>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import APPurchaseHistory from "@/components/common/APPurchaseHistory";
import APMsg from "@/components/common/APMsg";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    APMsg,
    breadcrumb,
    APPurchaseHistory,
  },
  data() {
    return {
      returnCode: "",
      orderCode: "",
      returnMoney: "",
      isShowAddBtn: true, // 是否展示右侧添加的按钮
      EntpTempGoodsIdEdit: "",
      loading: false,
      dataReadonly: false,
      APMsgVisible: false,
      historyVisible: false,
      outItem: {},
      allNum: 0,
      allMoney: 0,
      refundAmount: 0,
      editIndex: -1,
      submitData: {
        WarehouseId: "",
        PReturnId: "", //退货单id
        EntpCusId: "", //供应商id
        EntpCusPOId: "", //采购单id
        ReturnTime: new Date(),
        ApplyAmount: 0,
        PayType: "",
        Reasons: "",
        SubmissionState: 0,
        DetailList: [],
      },
      Limit: 30,
      codeList: [],
      nameList: [],
      dataList: [],
      selectedList: [],
      warehouseList: [],
      payWayList: [],
      type: 0,
      pageTitle: "",
      rules: {
        WarehouseId: [{ required: true, message: "选择仓库", trigger: "blur" }],
        EntpCusId: [{ required: true, message: "选择供应商", trigger: "blur" }],
        ReturnTime: [
          { required: true, message: "填写售后时间", trigger: "blur" },
        ],
        Reasons: [{ required: true, message: "填写售后原因", trigger: "blur" }],
      },
      infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
      permission: {},
      changeCodeConfig: true,
      apcodeSource: null,
      // 是否预先加载汽配编码列表数据
      isPreloadApCodeList: false,
      selectLoading: false,
      // 用于汽配编码列表，分页搜索功能
      codeForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 用于配件名称列表，分页搜索功能
      nameForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 用于车型列表，分页搜索功能
      seriesList: [],
      autoSerieForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 加锁：选择商品完成回车或点加号后触发锁定不可修改
      hasLock: true,
      // 阻止提交，防止多次提交
      stopSubmit: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  computed: {
    // 列表高度
    infiniteTableHeight() {
      return this.infiniteListHeight - 24;
    },
    // 是否加锁
    isLock() {
      return this.hasLock;
    },
    // 列表数据最后一行下标
    lastRowIndex() {
      return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
    },
  },
  created() {
    this.type = Number(this.$route.query.type);
    this.getKdyjzCofig();
    this.getKdbjsdConfig();
  },
  mounted() {
    //采购退货单权限
    this.permission = this.$util.getPermission("purchasesReturns");

    this.id = this.$route.query.orderId;
    this.submitData.EntpCusId = this.$route.query.entpCusId;
    this.submitData.EntpCusName = this.$route.query.entpCusName;
    this.submitData.ReleOrderId = this.$route.query.orderId;
    this.submitData.ReleType = this.$route.query.releType;
    this.submitData.ApplyAmount = this.$route.query.return;
    this.type = Number(this.$route.query.type);
    let _dataList = this.$util.getLocalStorage("UnionTansOrder");
    for (let i = 0; i < _dataList.length; i++) {
      this.dataList.push({
        EntpTempGoodsId: _dataList[i].MyGoodsId,
        APCode: _dataList[i].MyAPCode,
        GoodName: _dataList[i].GoodName,
        GoodNameItem: _dataList[i].GoodName,
        AutoSerise: _dataList[i].AutoSerise,
        AutoSeriseItem: _dataList[i].AutoSerise,
        ReturnCount: _dataList[i].Count,
        PurchasePrice: _dataList[i].Price,
        Unit: _dataList[i].Unit,
        Remark: "",
        // CostPrice: "",
        State: 0,
        WasteCount: 0,
        // WaitingOutQuantity: 0,
        // Inventory: 0, //商品总数量
        // StorageInventory: 0, //仓库库存数量
        // POrderWaitInQuantity: 0,
        // OrderWaitOutQuantity: 0,
        hasLock: this.hasLock,
      });
    }
    // 上锁
    if (this.isLock && this.dataList.length > 1) {
      this.dataList.forEach((ele) => {
        ele.hasLock = true;
      });
    }
    this.priceChange();

    // 监听滚动事件
    window.onresize = () => {
      this.resetHeight();
    };
    setTimeout(() => {
      this.resetHeight();
    }, 0);

    this.getTranReturnOrderDefaultData();
  },
  methods: {
    /**
     * 获取权限：选择商品完成回车或点加号后触发锁定不可修改
     * 只在新增和编辑时获取
     */
    getKdbjsdConfig() {
      this.$util.getSysConfig("kdbjsd").then((data) => {
        this.hasLock = data.Result;
      });
    },
    // 获取预加载商品数据的功能设置结果
    getKdyjzCofig() {
      this.$util.getSysConfig("kdyjz").then((res) => {
        this.isPreloadApCodeList = res.Result;
      });
    },
    // 计算infinite-list高度
    resetHeight() {
      let listObj = document.getElementById("infinite-list");
      if (!listObj) return;
      let clientObj = listObj.getBoundingClientRect();
      this.infiniteListHeight = window.innerHeight - clientObj.top;
    },
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog(edit) {
      this.APMsgVisible = false;
    },
    getTranReturnOrderDefaultData() {
      let that = this;

      if (that.dataList) {
        let ids = [];
        that.dataList.forEach((e, i) => {
          if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
        });
        if (ids.length > 0) {
          that.$util
            .axiosPost({
              url: "/api/EntpUnions/GetTranReturnOrderDefaultData",
              data: {
                EntpCusId: that.submitData.EntpCusId,
                GoodsIds: ids,
                WarehouseId: that.submitData.submitData,
              },
            })
            .then((res) => {
              if (res.data) {
                let data = res.data.DetailList;
                that.dataList.forEach((e, i) => {
                  let goodsData = data.find(
                    (d) => d.GoodsId == e.EntpTempGoodsId
                  );
                  if (goodsData) {
                    e.WasteCount = goodsData.WasteCount;
                    e.Inventory = goodsData.Inventory;
                    e.State = goodsData.State;
                  } else {
                    e.WasteCount = 0;
                    e.Inventory = 0;
                  }
                });
              }
            })
            .catch(() => {});
        }
      }
    },
    // 数量或者价格变动
    priceChange(index) {
      let DetailList = this.dataList;
      let _allNum = 0;
      let _allMoney = 0;
      for (let i = 0; i < DetailList.length; i++) {
        _allNum += Number(DetailList[i].ReturnCount);
        _allMoney += Number(
          DetailList[i].ReturnCount * DetailList[i].PurchasePrice
            ? (DetailList[i].ReturnCount * DetailList[i].PurchasePrice).toFixed(
                2
              )
            : 0
        );
      }
      this.allMoney = _allMoney;
      this.allNum = _allNum;
    },
    // 提交采购售后单
    submitForm(SubmissionState) {
      this.$refs["formMsg"].validate((valid) => {
        if (valid) {
          let _dataList = [];
          if (this.type == 0) _dataList = this.selectedList;
          else {
            if (this.dataList.length > 0) {
              this.dataList.forEach((item) => {
                if (item.EntpTempGoodsId) _dataList.push(item);
              });
            }
          }

          if (_dataList.length == 0 && this.submitData.ApplyAmount == 0) {
            this.$util.warningMsg("售后必须至少具备退货或退款其中一项");
            return;
          }

          if (this.submitData.ApplyAmount > 0) {
            if (!this.submitData.PayType) {
              this.$util.warningMsg("当申请退款时，退款方式必须选择哟");
              return;
            }
          }

          for (let i = 0; i < _dataList.length; i++) {
            if (!_dataList[i].APCode) {
              this.$util.warningMsg("请填写配件编码");
              return;
            }
            if (!_dataList[i].GoodName) {
              this.$util.warningMsg("请填写配件名称");
              return;
            }
            if (_dataList[i].State != 0) {
              this.$util.warningMsg(
                "商品【" +
                  _dataList[i].GoodName +
                  "（" +
                  _dataList[i].APCode +
                  "）" +
                  "】已删除"
              );
              return;
            }

            if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
              this.$util.warningMsg("请填写正确的退货数量");
              return;
            }
            if (
              _dataList[i].CanReturnCount &&
              _dataList[i].ReturnCount > _dataList[i].CanReturnCount
            ) {
              this.$util.warningMsg("可退货数量不足");
              return;
            }
          }
          this.submitData.SubmissionState = SubmissionState;
          this.submitData.DetailList = _dataList;

          let checkRepeat = this.checkRepeatAndReturnData();
          if (checkRepeat.hasRepeat) {
            this.$confirm("订单含有重复商品项，是否需要累加", "", {
              type: "error",
              distinguishCancelAndClose: true,
            })
              .then(() => {
                // 覆盖数据
                this.dataList = checkRepeat.row;
                this.submitData.DetailList = checkRepeat.row;
                this.submitFormAgain(SubmissionState);
              })
              .catch(() => {});
          } else {
            this.submitFormAgain(SubmissionState);
          }
        } else {
          this.$util.warningMsg("有必填项未填写");
        }
      });
    },
    submitFormAgain(SubmissionState) {
      this.loading = true;
      this.stopSubmit = true;
      this.$util
        .axiosPost({
          url: "/api/EntpUnions/TranEntpPurDirectReturnOrder",
          data: this.submitData,
          hideLoading: true,
        })
        .then(() => {
          if (SubmissionState) {
            this.$util.successMsg("提交采购售后单成功");
          } else {
            this.$util.successMsg("保存采购售后单成功");
          }
          this.$store.commit("updateNeedRefresh", true);
          setTimeout(() => {
            this.$router.push("/purchaseManage/purchasesReturns");
          }, 2000);
        })
        .catch(() => {
          this.stopSubmit = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 检查是否有重复项及返回已合并数量的数据
    checkRepeatAndReturnData() {
      let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
      list.forEach((item) => {
        let index = row.findIndex((f) => f.APCode === item.APCode);
        if (index > -1) {
          hasRepeat = true;
          row[index].ReturnCount += item.ReturnCount;
        } else {
          row.push(Object.assign({}, item));
        }
      });
      return {
        hasRepeat,
        row,
      };
    },
    // 删除某行
    delItem(index) {
      this.dataList.splice(index, 1);
      this.priceChange();
    },
    // 添加一行
    addItem() {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }

        if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
          this.$util.warningMsg("请填写正确的退货数量");
          return;
        }
        if (
          _dataList[i].CanReturnCount &&
          _dataList[i].ReturnCount > _dataList[i].CanReturnCount
        ) {
          this.$util.warningMsg("可退货数量不足");
          return;
        }
      }

      // 上锁
      if (this.isLock) {
        this.dataList.forEach((ele) => {
          ele.hasLock = true;
        });
      }

      this.dataList.push({
        EntpTempGoodsId: "",
        PurchaseQuantity: 0,
        CanReturnCount: 0,
        ReturnCount: 0,
        APCode: "",
        GoodName: "",
        AutoSerise: "",
        Unit: "",
        PurchasePrice: 0,
        State: 0,
        WasteCount: 0,
      });

      setTimeout(() => {
        this.$refs.infiniteTable.scrollToRow(
          this.dataList[this.dataList.length - 1]
        );
        this.$refs.infiniteTable.setActiveRow(
          this.dataList[this.dataList.length - 1]
        );
        if (this.dataList.length > 1) {
          let ilEle = document.getElementsByClassName(
            "elx-table--body-wrapper"
          )[0];
          ilEle.scrollTop = ilEle.scrollHeight;
        }
      }, 100);

      this.priceChange();
    },
    // 解锁
    upLock(index) {
      this.$set(
        this.dataList,
        index,
        Object.assign({}, this.dataList[index], {
          hasLock: !this.dataList[index].hasLock,
        })
      );
    },
    // 搜索编码
    searchCode(key) {
      // 取消请求
      if (this.apcodeSource) {
        this.apcodeSource.cancel();
      }
      let url = "";
      if (!this.submitData.EntpCusId) {
        this.$util.warningMsg("请选择供应商");
        return;
      }
      url = "/api/EntpPurReturnOrder/GetGoodsListBySupplier";
      let _dataList = [];
      if (this.type == 0) _dataList = this.selectedList;
      else _dataList = this.dataList;
      let selectedIds = [];
      if (_dataList.length > 0) {
        _dataList.forEach((item) => {
          if (item.EntpTempGoodsId) selectedIds.push(item.EntpTempGoodsId);
        });
      }
      if (![undefined].includes(key)) {
        this.codeForm.Page = 1;
        this.codeForm.stopLoad = false;
        this.codeForm.key = key;
        this.codeList = [];
      }
      if (this.codeForm.stopLoad) return;
      this.selectLoading = true;
      // 初始化对象
      this.apcodeSource = this.axios.CancelToken.source();
      this.$util
        .axiosPost({
          url: url,
          data: {
            APCode: this.codeForm.key,
            Page: this.codeForm.Page,
            Limit: this.codeForm.Limit,
            OrderId: this.submitData.EntpCusPOId,
            CusId: this.submitData.EntpCusId,
            SelectedIds: selectedIds,
          },
          hideLoading: true,
          cancelToken: this.apcodeSource.token, // 取消操作标识
        })
        .then((res) => {
          this.selectLoading = false;
          if(!res.data) return;
          this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
          this.codeList = this.$util.uniqueArr(this.codeList, res.data);
        });
    },
    // 汽配编码列表，加载更多
    searchCodeLoad() {
      if (!this.selectLoading) {
        this.codeForm.Page += 1;
        this.searchCode();
      }
    },
    // 搜索名称
    searchName(key) {
      let url = "";
      if (!this.submitData.EntpCusId) {
        this.$util.warningMsg("请选择供应商");
        return;
      }
      url = "/api/EntpPurReturnOrder/GetGoodsListBySupplier";
      let _dataList = [];
      if (this.type == 0) _dataList = this.selectedList;
      else _dataList = this.dataList;
      let selectedIds = [];
      if (_dataList.length > 0) {
        _dataList.forEach((item) => {
          if (item.EntpTempGoodsId) selectedIds.push(item.EntpTempGoodsId);
        });
      }
      if (![undefined].includes(key)) {
        this.nameForm.Page = 1;
        this.nameForm.stopLoad = false;
        this.nameForm.key = key;
        this.nameList = [];
      }
      if (this.nameForm.stopLoad) return;
      this.selectLoading = true;
      this.$util
        .axiosPost({
          url: url,
          data: {
            GoodName: this.nameForm.key,
            Page: this.nameForm.Page,
            Limit: this.nameForm.Limit,
            OrderId: this.submitData.EntpCusPOId,
            CusId: this.submitData.EntpCusId,
            SelectedIds: selectedIds,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.selectLoading = false;
          if(!res.data) return;
          this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
          this.nameList = this.$util.uniqueArr(this.nameList, res.data);
        });
    },
    // 汽配名称列表，加载更多
    searchNameLoad() {
      this.nameForm.Page += 1;
      this.searchName();
    },
    // 搜车系
    searchAutoSerie(key, item) {
      if (!this.submitData.EntpCusId) {
        this.$util.warningMsg("请选择供应商");
        return;
      }
      if (![undefined].includes(key)) {
        this.autoSerieForm.Page = 1;
        this.autoSerieForm.stopLoad = false;
        this.autoSerieForm.key = key;
        this.seriesList = [];
      }
      if (this.autoSerieForm.stopLoad) return;
      let _dataList = [];
      if (this.type == 0) _dataList = this.selectedList;
      else _dataList = this.dataList;
      let selectedIds = [];
      if (_dataList.length > 0) {
        _dataList.forEach((item) => {
          if (item.EntpTempGoodsId) selectedIds.push(item.EntpTempGoodsId);
        });
      }
      this.selectLoading = true;
      this.$util
        .axiosPost({
          url: "/api/EntpPurReturnOrder/GetGoodsListBySupplier",
          data: {
            SeriesName: this.autoSerieForm.key,
            Page: this.autoSerieForm.Page,
            Limit: this.autoSerieForm.Limit,
            OrderId: this.submitData.EntpCusPOId,
            CusId: this.submitData.EntpCusId,
            SelectedIds: selectedIds,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.selectLoading = false;
          if(!res.data) return;
          this.autoSerieForm.stopLoad =
            res.data.length < this.autoSerieForm.Limit;
          this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);
        });
    },
    // 车系列表，加载更多
    searchAutoSerieLoad() {
      this.autoSerieForm.Page += 1;
      this.searchAutoSerie();
    },
    // 名称改变
    nameChange(item, index) {
      if (!this.dataList[index].APCode) {
        this.dataList[index].APCode = item.APCode;
        this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
        this.dataList[index].State = 0;
      }
      this.dataList[index].CanReturnCount = item.CanReturnCount;
      this.dataList[index].GoodName = item.GoodName;
      this.dataList[index].Unit = item.Unit;
      this.dataList[index].AutoSerise = item.AutoSerise;
      this.dataList[index].AutoSeriseItem = item.AutoSerise;
      this.dataList[index].PurchasePrice = item.PurchasePrice;
      this.dataList[index].PurchaseQuantity = item.PurchaseQuantity;
      this.dataList[index].ReturnCount = item.ReturnCount;
      this.dataList[index].WasteCount = item.WasteCount;
      this.priceChange();
    },
    // 编码改变
    codeChange(value, index) {
      let _list = this.codeList;
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].APCode == value) {
          let item = _list[i];
          this.dataList[index].APCode = item.APCode;
          this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
          this.dataList[index].State = 0;
          this.dataList[index].CanReturnCount = item.CanReturnCount;
          this.dataList[index].GoodName = item.GoodName;
          this.dataList[index].Unit = item.Unit;
          this.dataList[index].AutoSerise = item.AutoSerise;
          this.dataList[index].AutoSeriseItem = item.AutoSerise;
          this.dataList[index].PurchasePrice = item.PurchasePrice;
          this.dataList[index].PurchaseQuantity = item.PurchaseQuantity;
          this.dataList[index].ReturnCount = item.ReturnCount;
          this.dataList[index].CanReturnCount = item.CanReturnCount;
          this.dataList[index].WasteCount = item.WasteCount;
          break;
        }
      }

      this.priceChange();
    },
    //车型改变  AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
    seriseChange(item, index) {
      this.editIndex = index;
      if (!item) {
        this.dataList[index].AutoSerise = "";
      } else if (typeof item == "string") {
        this.dataList[index].AutoSerise = item;
      } else {
        this.dataList[index].APCode = item.APCode;
        this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
        this.dataList[index].GoodName = item.GoodName;
        this.dataList[index].GoodNameItem = item.GoodName;
        this.dataList[index].VGoodName = item.GoodName;
        this.dataList[index].Price = item.CostPrice;
        this.dataList[index].Unit = item.Unit;
        this.dataList[index].AutoSerise = item.AutoSerise;
        this.dataList[index].State = 0;

        this.dataList[index].Inventory = item.Inventory;
        this.dataList[index].StorageInventory = item.StorageInventory;
        this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
        this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
        this.priceChange();
      }
    },
    //当汽配件编码下拉框出现时触发
    apCodeVisibleChange(event) {
      let that = this;
      if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
        //if (that.codeList.length == 0) {
        that.searchCode('');
        setTimeout(() => {
          if (that.codeList && that.codeList.length > 0) {
            that.nameList = that.codeList.concat([]);
          }
        }, 2000);
        //}
      }
    },
    //当汽配件名称下拉框出现时触发
    apNameVisibleChange(event) {
      let that = this;
      if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
        //if (that.nameList.length == 0) {
        that.searchName('');
        // setTimeout(() => {
        //   if (that.nameList && that.nameList.length > 0) {
        //     that.codeList = that.nameList.concat([]);
        //   }
        // }, 2000);
        //}
      }
    },
    //当车系下拉框出现时触发
    autoSeriseVisibleChange(event, item) {
      let that = this;
      if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
        that.searchAutoSerie("", item);
      }
    },
    getWarehouse() {
      this.$util.getWarehouse(1).then((data) => {
        this.warehouseList = data;
      });
    },
    warehouseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.warehouseList.length <= 1) that.getWarehouse();
      }
    },
    getPay() {
      this.$util.getPay().then((data) => {
        this.payWayList = data;
      });
    },
    payTypeVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.payWayList.length <= 1) that.getPay();
      }
    },
    // 点击展开下拉框
    focusHandle(isNew, index, type) {
      if (type === "code" && !isNew) {
        setTimeout(() => {
          this.$refs[`code${index}`].focus();
        }, 200);
      }
      if (type === "partsNameSelect" && !isNew) {
        setTimeout(() => {
          this.$refs[`partsNameSelect`].focus();
        }, 200);
      }
      if (type === "autoSeriseSelect" && !isNew) {
        setTimeout(() => {
          this.$refs[`autoSeriseSelect`].focus();
        }, 200);
      }
    },
    setSummaries() {
      return [
        [
          "",
          "",
          "",
          "",
          "",
          "总数量",
          this.allNum,
          "合计",
          this.allMoney.toFixed(2),
        ],
      ];
    },
    // 设置展示行样式
    setRowStyle(param) {
      const { row, index } = param;
      let rowArr = this.dataList.filter((f) => f.APCode === row.APCode);
      if (rowArr.length > 1) {
        return `background-color: #FFE8E8`;
      }
    },
    showHistories(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.historyVisible = true;
      }
    },
    closeHistoryDialog() {
      this.historyVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;

  span {
    margin-right: 20px;
  }
}
.option-content {
  display: flex;
  line-height: 30px;

  .project-Name {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 12px;
  }
}
.btn-ctn {
  padding-top: 30px;
  margin-right: 110px;
  text-align: right;
}
.add-btn {
  position: absolute;
  right: -40px;
  bottom: 0;
}
.less-btn {
  position: absolute;
  right: -40px;
  top: 0;
  z-index: 2;
}
.business-content-main {
  width: 100%;
}
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 15px;
  margin-bottom: 15px;
}
.bottom-div {
  margin-top: 10px;
  text-align: right;
}
// .my-input-sc {
//   display: inline-block;
//   -webkit-appearance: none;
//   background-color: #ffffff;
//   background-image: none;
//   border-radius: 4px;
//   border: 1px solid #dcdfe6;
//   box-sizing: border-box;
//   color: #606266;
//   font-size: inherit;
//   outline: none;
//   padding: 15px;
//   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
//   width: 100%;
// }
.special-border {
  height: 100%;
  border-radius: 3px;
  border: 1px solid #ffcc00;
}
</style>
<style lang="less">
.check-code-class {
  .el-input__inner {
    border: 1px solid #f56c6c;
  }
}
.purreturn-order-edit {
  .el-row {
    margin-bottom: 0px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  .elx-table {
    .elx-table--body-wrapper {
      .elx-body--row {
        .table-sort {
          .elx-cell {
            padding: 4px 12px 0;
          }
        }
        .table-check {
          .elx-cell {
            padding: 4px 12px 0;
          }
        }
        .div-padding-12 {
          padding: 4px 12px 0;
        }
        .operate {
          padding: 0 12px;
        }
        td {
          height: 26px;
        }
      }
      .elx-cell {
        padding: 0;
        height: 32px;
      }
      .el-button--small {
        padding: 5px 15px;
        margin: 3px 9px 0 0;
      }
    }
    .elx-table--footer-wrapper {
      margin-top: 0 !important;
      .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
    }
    .elx-table--body-wrapper {
      padding-bottom: 220px !important;
    }
  }
  .sales-input-cell {
    .el-input-number {
      width: 100%;
    }
    .el-input {
      .el-input__inner {
        padding-left: 0;
        padding-right: 20px;
      }
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 20px;
    }
  }
  .unit-input-cell {
    .el-input {
      .el-input__inner {
        padding-right: 20px;
      }
    }
  }
  .sales-apcode {
    .el-tag {
      height: 24px;
      line-height: 22px;
      margin-left: 8px;
    }
  }
}
</style>
